import fyllaVertical from "../photos/fyllaVertical.svg";
import globe from "../photos/globe.svg";
import linkArrow from "../photos/linkArrow.svg";
import chevronWhite from "../photos/BiChevronsRightWhite.svg";

const Menu = ({
  isMenuAnimating,
  containerHeight,
  changeLanguage,
  language,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  closeMenu,
  t,
}) => {
  const linkWidths = {
    norsk: {
      "terms-of-sale": "240px",
      "privacy-policy": "166px",
      "terms-of-service": "95px",
    },
    default: {
      "terms-of-sale": "184px",
      "privacy-policy": "203px",
      "terms-of-service": "223px",
    },
  };

  const links = [
    { href: "/terms-of-sale", label: "terms-of-sale" },
    { href: "/privacy-policy", label: "privacy-policy" },
    { href: "/terms-of-service", label: "terms-of-service" },
  ];

  return (
    <div
      className={`menu-container ${isMenuAnimating ? "menu-close" : ""}`}
      style={{ height: containerHeight - 48 }}
    >
      <div className="fylla-vertical-container">
        <img className="fylla-vertical" src={fyllaVertical} alt="" />
      </div>
      <div className="menu-item">
        <div className="container-row-end" onClick={changeLanguage}>
          <div
            className="button-tertiary-s button-text-s text-color-white"
            style={{
              maxWidth: "203px",
              maxHeight: "28px",
              marginRight: "10px",
              textTransform: "uppercase",
              color: "white",
            }}
          >
            {language}
          </div>
          <img
            style={{ marginRight: "70px", paddingTop: "3px" }}
            src={globe}
            alt=""
          />
        </div>
        <a
          className="container-row-start"
          href="https://www.instagram.com/fyl.la_/"
          rel="noopener noreferrer"
        >
          <h1
            style={{
              marginTop: "20px",
              maxWidth: "115px",
              maxHeight: "57px",
              fontWeight: 700,
              fontSize: "42px",
              fontStyle: "italic",
            }}
          >
            INSTA
          </h1>
          <img
            style={{ marginLeft: "10px", paddingTop: "0px" }}
            src={linkArrow}
            alt=""
          />
        </a>
      </div>
      <div
        className="swipe-area"
        style={{ justifyContent: "flex-end" }}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <img
          className="stuttering-arrow-left"
          style={{ paddingRight: "48px" }}
          src={chevronWhite}
          onClick={closeMenu}
          alt=""
        />
      </div>
      <div className="menu-item" style={{ justifyContent: "end" }}>
        {links.map(({ href, label }) => (
          <a
            key={label}
            className="button-tertiary-m button-text-m text-color-white"
            href={href}
            rel="noopener noreferrer"
            style={{
              maxWidth:
                language === "norsk"
                  ? linkWidths.norsk[label]
                  : linkWidths.default[label],
              maxHeight: "32.5px",
            }}
          >
            {t(label)}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Menu;
